module.exports = __webpack_public_path__ + "img/u151.49a4c9cc.svg";